import React from 'react'
import { BiTrash } from 'react-icons/bi'
import styles from './styles.module.css'

export default function TrashButton({ onClick, className }) {
  return (
    <i
      className={`${styles.trash} ${className || ''}`}
      onClick={onClick}
    >
      <BiTrash />
    </i>
  )
}
